import { backendRequest } from "../../../stores/thunks";
import store from "../../../stores/store";

export default async function createNewWorkflow(data) {

    const newWorkflow = {
        id: null, title: '', text: '', step: -1, media: [], steps: [], owned: true, settings: {}, changed: new Date().getTime(),
        flowData: {
            nodes: [
                {
                    id: 'startOfWorkflow',
                    data: {
                        title: '',
                        description: '',
                        media: [],
                        nodeType: 'workflowStartNode',
                        updateNode: null
                    },
                    deletable: false,
                    position: { x: 80, y: 250 },
                    type: 'workflowStartNode',
                },
                {
                    id: 'endOfWorkflow',
                    data: {
                        title: '',
                        description: '',
                        media: [],
                        nodeType: 'endNode',
                        updateNode: null
                    },
                    deletable: false,
                    position: { x: 700, y: 250 },
                    type: 'endNode',
                }
            ],
            edges: []
        }
    }

    try {
        const result = await store.dispatch(backendRequest('STUDIO_CREATE_WORKFLOW', '/studio/workflow', {
            name: data ? data.nodes[0].data.title : newWorkflow.flowData.nodes[0].data.title,
            description: data ? data.nodes[0].data.description : newWorkflow.flowData.nodes[0].data.description,
            workflowData: JSON.stringify(data ? { ...newWorkflow, flowData: data } : newWorkflow)
        }, 'POST', false))
        console.log('STUDIO CREATE', result)
        return result
    } catch (error) {
        console.log('STUDIO CREATE: Error', error)
        return error
    }
}